import { Injectable } from '@angular/core';
import {Store} from "@ngrx/store";
import * as componentActions from "@catdetails/actions/ggw";
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class GgwDevZoneAssignmentService extends RestHttpService<any> {

  constructor(private service: Restangular,
              private store: Store<any>) {
    super('ggw-device-zone-assignments', service);
  }

  setActive() {
    //this.store.dispatch({type: componentActions.PROJECT_DETAILS_GGW_ACTIVATE});
  }

  setInActive() {
    //this.store.dispatch({type: componentActions.PROJECT_DETAILS_GGW_DEACTIVATE});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-dev-zone-assignment/services/ggw-dev-zone-assignment.service.ts